import history from 'utils/routeHistory';

export function redirectTo(route) {
  history.push(route);
}



// WEBPACK FOOTER //
// ./app/containers/PrivateRoute/actions.js